<h2 mat-dialog-title>{{ data.title }}</h2>
<mat-dialog-content class="remit-preview-dialog">
	<div *ngIf="loading" class="text-center py-5">
		<mat-spinner diameter="40"></mat-spinner>
		<p class="text-muted mt-2">Building preview from current data…</p>
	</div>
	<ng-container *ngIf="!loading && results.length === 1">
		<div *ngFor="let row of results" class="single-preview">
			<p *ngIf="row.res.subject" class="text-muted small mb-2"><strong>Subject:</strong> {{ row.res.subject }}</p>
			<ul *ngIf="row.res.warnings?.length" class="warnings-list">
				<li *ngFor="let w of row.res.warnings">{{ w }}</li>
			</ul>
			<p *ngIf="!row.res.success && row.res.message" class="text-warning">{{ row.res.message }}</p>
			<iframe
				*ngIf="row.trustedHtml"
				class="remit-frame"
				title="Remittance preview"
				[srcdoc]="row.trustedHtml"
				sandbox=""
			></iframe>
		</div>
	</ng-container>
	<mat-tab-group *ngIf="!loading && results.length > 1" animationDuration="0ms" class="remit-tabs">
		<mat-tab *ngFor="let row of results" [label]="row.label">
			<div class="tab-inner">
				<p *ngIf="row.res.subject" class="text-muted small mb-2"><strong>Subject:</strong> {{ row.res.subject }}</p>
				<ul *ngIf="row.res.warnings?.length" class="warnings-list">
					<li *ngFor="let w of row.res.warnings">{{ w }}</li>
				</ul>
				<p *ngIf="!row.res.success && row.res.message" class="text-warning">{{ row.res.message }}</p>
				<iframe
					*ngIf="row.trustedHtml"
					class="remit-frame"
					title="Remittance preview"
					[srcdoc]="row.trustedHtml"
					sandbox=""
				></iframe>
			</div>
		</mat-tab>
	</mat-tab-group>
</mat-dialog-content>
<mat-dialog-actions align="end">
	<button mat-button type="button" (click)="close()">Close</button>
</mat-dialog-actions>
